import { useState } from 'react';
import useSWR from 'swr';

import { Combobox } from '../../components/combobox/Combobox';
import { displayTrailer, type TrailerOption } from './displayTrailer';
import { fetchTrailerList } from './models';

export interface ITrailerComboboxProps {
  value: TrailerOption | null;
  onChange: (trailer: TrailerOption | null) => void;
  onBlur?: () => void;
  isDisabled?: boolean;
  isInvalid?: boolean;
}

/** Searches the active internal trailers. */
export const TrailerCombobox: React.FC<ITrailerComboboxProps> = (props) => {
  const { value, onChange, onBlur, isDisabled, isInvalid } = props;
  const [searchValue, setSearchValue] = useState('');

  const { data, isLoading } = useSWR(['trailers-combobox', searchValue], () =>
    fetchTrailerList({ search: searchValue, isActive: true }),
  );

  return (
    <Combobox<TrailerOption>
      keyName="id"
      placeholder="Zoek een trailer..."
      onQueryChange={setSearchValue}
      display={displayTrailer}
      items={data ?? []}
      selectedItem={value}
      onSelect={onChange}
      onBlur={onBlur}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      isNullable={true}
      // Without this the dropdown is empty while the search runs, which reads as "no trailers".
      isLoading={isLoading}
    />
  );
};
